import { type HttpErrorResponse, type HttpEvent, type HttpHandler, type HttpInterceptor, type HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { captureException } from '@sentry/browser';
import { type Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { FeatureFlagsService } from '../..';

@Injectable()
export class LogSentryInterceptor implements HttpInterceptor {
    private readonly featureFlagService = inject(FeatureFlagsService);

    public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                if (this.featureFlagService.isFeatureEnabled('global-error-tracking')()) {
                    captureException(JSON.stringify(error));
                }

                return throwError(() => error)
            }),
        );
    }
}
